
export const getAccount = (username, password) =>
    fetch( process.env.REACT_APP_U1_VIEWERSVC_CONNECT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
        credentials: 'include'
    })

export const getUser = () => 
    fetch( process.env.REACT_APP_U1_VIEWERSVC_GETUSER_URL+'/name', {
        method: 'GET',
        credentials: 'include'
    })


export const logout = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_U1_GATEWAY_BASE_URL + '/logout', {
            method: 'POST',
            credentials: 'include' 
        });
        return response.ok;
    } catch (error) {
        console.error('Error during logout:', error);
        return false;
    }
}

export const checkAuthStatus = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_U1_VIEWERSVC_GETUSER_URL+'/auth-check', {
            method: 'GET',
            credentials: 'include'
        })
        return response.ok;
    } catch (error) {
        console.error('Error checking auth status:', error)
        return false
    }
}